import { useTranslation } from 'react-i18next';
import { IoIosInformationCircle } from 'react-icons/io';

import { LegalWarning } from '@/components/legal-warning';

/**
 * Dark info box shown above the QA agent form. Mirrors the upload info panels
 * used by the other package-creation wizards: a "How it works" section followed
 * by the shared legal warning copy.
 */
export function QaAgentUploadInfo() {
  const { t } = useTranslation();

  return (
    <div className="bg-day-light-3 border border-day-light-1 rounded-lg p-4 w-full">
      <div className="mb-3 flex gap-2">
        <span className="mt-0.5 flex-shrink-0">
          <IoIosInformationCircle size={18} color="#7588a3" />
        </span>
        <div className="text-sm">
          <p>
            <strong>{t('package-creation.qa-agent.how-it-works-title')}</strong>{' '}
            {t('package-creation.qa-agent.how-it-works-body')}
          </p>
        </div>
      </div>

      <div className="flex gap-2">
        <span className="mt-0.5 flex-shrink-0">
          <IoIosInformationCircle size={18} color="#7588a3" />
        </span>
        <LegalWarning className="text-sm" />
      </div>
    </div>
  );
}
